<script>

    export default {

        props: ['source'],

        data() {
            return {
                pages: [],
                quantidadePaginas: 7
            }
        },

        watch: {
            source() {
                this.alteraQuantidadePaginas();
                this.pages = this.generatePagesArray(this.source.current_page, this.source.total, this.source.per_page, this.quantidadePaginas)
            }
        },

        methods: {
            _navigate(ev, page) {
                this.$emit('navigate', page);
                this.$set(this.source, 'current_page', page)
            },

            next() {
                if (this.source.current_page >= this.source.last_page) {
                    return
                }

                this.$set(this.source, 'current_page', this.source.current_page + 1);
                this.$emit('navigate', this.source.current_page)
            },

            prev() {
                if (this.source.current_page <= (this.source.current_page == 1)) {
                    return
                }

                this.$set(this.source, 'current_page', this.source.current_page - 1);
                this.$emit('navigate', this.source.current_page)
            },

            generatePagesArray: function (currentPage, collectionLength, rowsPerPage, paginationRange) {
                let pages = [];
                let totalPages = Math.ceil(collectionLength / rowsPerPage);
                let halfWay = Math.ceil(paginationRange / 2);
                let position;

                if (currentPage <= halfWay) {
                    position = 'start';
                } else if (totalPages - halfWay < currentPage) {
                    position = 'end';
                } else {
                    position = 'middle';
                }

                let ellipsesNeeded = paginationRange < totalPages;
                let i = 1;
                while (i <= totalPages && i <= paginationRange) {
                    let pageNumber = this.calculatePageNumber(i, currentPage, paginationRange, totalPages);
                    let openingEllipsesNeeded = (i === 2 && (position === 'middle' || position === 'end'));
                    let closingEllipsesNeeded = (i === paginationRange - 1 && (position === 'middle' || position === 'start'));
                    if (ellipsesNeeded && (openingEllipsesNeeded || closingEllipsesNeeded)) {
                        pages.push('...');
                    } else {
                        pages.push(pageNumber);
                    }
                    i++;
                }
                return pages;
            },

            calculatePageNumber: function (i, currentPage, paginationRange, totalPages) {
                let halfWay = Math.ceil(paginationRange / 2);
                if (i === paginationRange) {
                    return totalPages;
                } else if (i === 1) {
                    return i;
                } else if (paginationRange < totalPages) {
                    if (totalPages - halfWay < currentPage) {
                        return totalPages - paginationRange + i;
                    } else if (halfWay < currentPage) {
                        return currentPage - halfWay + i;
                    } else {
                        return i;
                    }
                } else {
                    return i;
                }
            },

            alteraQuantidadePaginas() {
                this.$set(this, 'quantidadePaginas', ($(window).width() <= 430 ? 5 : 7));
            }
        },

        mounted() {
            let self = this;
            $(window).resize(function () {
                let ultimaQuantidade = self.quantidadePaginas;
                self.alteraQuantidadePaginas();
                if (ultimaQuantidade !== self.quantidadePaginas) {
                    self._navigate(null, self.source.current_page)
                }
            })
        }

    }

</script>

<template>

    <div>
        <div class="row">
            <div class="col-sm-5 registros">
                <div class="dataTables_info" v-if="source.from == 1 && source.to == 0 || source.from == undefined && source.to == undefined">
                    Mostrando de 0 até 0 de 0 registros
                </div>
                <div class="dataTables_info" v-else="">
                    Mostrando de {{source.from}} até {{source.to}} de {{source.total}} registros
                </div>
            </div>

            <div class="paginacao margin-right-1 dataTables_paginate paging_bootstrap">
                <div v-if="source.from == 1 && source.to == 0 || source.from == undefined && source.to == undefined">

                </div>

                <nav v-else="">
                    <ul style=" width: max-content;" class="pagination">
                        <li :class="{disabled:source.current_page == (source.current_page == 1)}">
                            <a class="page-link" @click="prev()" aria-label="Previous">
                                <i class="fa fa-chevron-left prev"></i>
                                <span class="textoprev" aria-hidden="true"> Anterior</span>
                                <span class="sr-only">Anterior</span>
                            </a>
                        </li>

                        <li v-for="page in pages" track-by="$index" :class="{active: source.current_page == page}">
                            <span v-if="page == '...'">{{ page }}</span>
                            <a class="page-link" v-if="page != '...'" @click="_navigate($event,  page)"> {{ page }}</a>
                        </li>

                        <li :class="{disabled:source.current_page == source.last_page}">
                            <a class="page-link" @click="next()" aria-label="Next">
                                <span class="textonext" aria-hidden="true"> Próximo </span>
                                <i class="fa fa-chevron-right next"></i>
                                <span class="sr-only">Próximo</span>
                            </a>
                        </li>
                    </ul>
                </nav>
            </div>

        </div>
    </div>

</template>

<style scoped>

    @media screen and (max-width: 865px) {
        .textoprev {
            display: none;
        }

        .prev {
            font-size: medium;
        }

        .textonext {
            display: none;
        }

        .next {
            font-size: medium;
        }

    }

    @media screen and (max-width: 767px) {

        .paginacao {
            text-align: center;
            float: none;
        }

        .registros {
            text-align: center;
        }

    }

    @media screen and (min-width: 990px ) and (max-width: 1100px ) {

        .textoprev {
            display: none;
        }

        .prev {
            font-size: medium;
        }

        .textonext {
            display: none;
        }

        .next {
            font-size: medium;
        }

    }

    @media screen and (max-width: 350px) {

        .prev {
            font-size: small;
        }

        .next {
            font-size: small;
        }

        .paginacao {
            text-align: center;
            float: none;
        }

        .registros {
            text-align: center;
        }

    }

    .paginacao {
        font-size: 75%;
    }

</style>
